import React from 'react';
import { ToastContainer } from 'react-toastify';

const UiNotifications = () => {
  return (
    <ToastContainer
      position="top-center"
      closeOnClick={true}
      pauseOnHover={true}
      draggable={true}
      theme="light"
      icon={false}
  />
  );
};

export default UiNotifications;
